import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { PbsApp } from '@ori/personal-beauty-store';
import type { PbsAppProps } from '@ori/personal-beauty-store';
import type { FC, PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { useAppConfig } from '../context';
import type { TopAreaProps } from './types';

export const Pbs: FC<PropsWithChildren<Pick<TopAreaProps, 'removeQueryParameter' | 'setQueryParameter'>>> = ({
  children,
  removeQueryParameter,
  setQueryParameter,
}) => {
  const { customerId } = useToken();
  const { currentLanguage, enableTopAreaBanner, pbsIconInBurgerMenu, tenant } = useAppConfig();
  const {
    globalApiUrl,
    graphQlUrl: graphqlUrl,
    identityUrl,
    staticApiUrl,
  } = useServiceUrls(['globalApi', 'graphQl', 'identity', 'staticApi']);
  const configuration = useMemo(
    (): PbsAppProps['configuration'] => ({
      currentLanguage,
      customerId,
      globalApiUrl,
      graphqlUrl,
      identityUrl,
      isEnabled: Boolean(enableTopAreaBanner) || Boolean(pbsIconInBurgerMenu),
      isTooltipEnabled: !enableTopAreaBanner,
      staticApiUrl,
      tenant,
    }),
    [
      currentLanguage,
      customerId,
      enableTopAreaBanner,
      globalApiUrl,
      graphqlUrl,
      identityUrl,
      pbsIconInBurgerMenu,
      staticApiUrl,
      tenant,
    ],
  );

  return (
    <PbsApp
      configuration={configuration}
      removeQueryParameter={removeQueryParameter}
      setQueryParameter={setQueryParameter}
    >
      {children}
    </PbsApp>
  );
};
